import { ColorTreeNoRepBuilder } from "../../General/Tree/colorTree/color-tree-no-rep-builder";
import { TreeNode } from "../../General/Tree/lib/tree-node";
import { Node } from "../../General/graph/lib/node";

export class ColoredFlagNoRep extends ColorTreeNoRepBuilder {
    protected hideMode: boolean = false;
    protected markedMode: boolean = false;
    protected deleteMode: boolean = false;
    cachedDeletedContent: TreeNode[] = [];

    leftClickTreeNode(treeNode: TreeNode) {

        if (this.hideMode) {
            let hide: boolean = !treeNode.isHidden();
            treeNode.setHidden(hide);
        }
        if (this.markedMode) {
            if (treeNode.isSelected()) {
                treeNode.resetColor();
            }
            else {
                treeNode.selected();
            }
        }
        if(this.deleteMode){
            this.deleteNode(treeNode);
        }
        this.resetModes();
        this.canvas.style.cursor = 'default';

    }

    selectHideMode(mode: boolean) {
        this.resetModes();
        this.hideMode = mode;
    }

    selectMarkedMode(mode: boolean) {
        this.resetModes();
        this.markedMode = mode;
    }

    selectDeleteMode(mode: boolean){
        this.resetModes();
        this.deleteMode = mode;
    }

    getHideMode(): boolean {
        return this.hideMode;
    }

    resetModes(){
        this.hideMode = false;
        this.markedMode = false;
        this.deleteMode = false;
    }

    deleteNode(delNode: Node) {
        if (delNode == null)
            return;

        let childrenToRemove: Node[] = [delNode];
        while (childrenToRemove.length > 0) {
            let parent: Node = childrenToRemove.shift();
            parent.getNeighbors().forEach(neighbor => {
                childrenToRemove.push(neighbor);
            });
            if (parent instanceof TreeNode) {
                this.cachedDeletedContent.push(parent);
                super.deleteNode(parent);
            }
        }
        this.update();
    }
    getHiddenNodesAsNodes(): TreeNode[]{
        let hiddenNodes: TreeNode[] = [];
        this.nodes.forEach(node => {
            if(node instanceof TreeNode){
                if(node.isHidden()){
                    hiddenNodes.push(node);
                }
            }
        })
        return hiddenNodes;
    }

    getDeletedNodes(): TreeNode[]{
        return this.cachedDeletedContent;
    }

    getMarkedNodes(): TreeNode[]{
        let markedNodes: TreeNode[] = [];
        this.nodes.forEach(node => {
            if(node instanceof TreeNode){
                if(node.isSelected()){
                    markedNodes.push(node);
                }
            }
        })
        return markedNodes;
    }

}
